import { Box, Button, ButtonGroup, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import { CloudDownloadRounded } from '@material-ui/icons';
import _ from 'lodash';
import { sumBy } from 'lodash-es';
import React, { Component } from 'react';
import { toast } from 'react-toastify';
import Currency from '../../../../commonModules/Currency';
import PopUp from '../../../../commonModules/interface/PopUp';
import SwipeableTabs from '../../../../commonModules/MUI/SwipeableTabs';
import { ListLayout } from '../containers/Layout';
import { BIN_TYPES } from '../products/SubProducts/FormSubProduct';

const UNITS = {
    cm3 : 1000000,
    m3 : 1000000000000,
    kg: 1000,
    g: 1,
}

class SingleBin extends Component {
    state = { 
        SUBS: {},
        volUnit : "m3",
        wUnit : "kg",

    }
    componentDidMount = async () => {
        // TO DO
        // fetch all product in this bin
        // calc total weight
        const req = await fetch("/stocks/getList",{
            method: "POST",
            headers: { 
                'Content-Type': 'application/json',
            },
            body:JSON.stringify({
                page: `bins/list/${this.props.bin.id}`,
            }),
            credentials: 'same-origin',
        })
        let res = await req.json()
        console.log('====================================');
        console.log({res});
        console.log('====================================');
        if (res.error) {
            toast.error("ERROR " + res.error)

            console.log('====================================');
            console.log("[ERROR]", res.error);
            console.log('====================================');
        } else {

           this.setState({
               SUBS: res
           })
        }
    }
    render() {
        const { bin } = this.props;
        const { SUBS, wUnit, volUnit } = this.state;
        console.log('================SingleBin SingleBin SingleBin====================');
        console.log({bin});
        console.log('====================================');
        const totalWeight = _.reduce(SUBS, (sum, obj) => sum + (obj.quantity * obj.product[0].poids), 0);
        const totalVolume = _.reduce(SUBS, (sum, obj) => sum + (obj.quantity * obj.product[0].largeur * obj.product[0].longueur * obj.product[0].hauteur), 0);
        // const totalVolume = _.reduce(SUBS, (sum, obj) => sum + (_.get(obj, 'product[0].quantity', 0) * _.get(obj, 'product[0].largeur', 0) * _.get(obj, 'product[0].longueur', 0) * _.get(obj, 'product[0].hauteur', 0)), 0);
        const volumeBin = bin.bin_largeur * bin.bin_longueur * bin.bin_hauteur
        
        return (
            <PopUp
                title={bin.bin_name}
                block={true}
                close={this.props.closeAll}
                // maxWidth="sm"
                // secondaryAction={
                //     <IconButton
                //         aria-label="download"
                //         // className={classes.closeButton}
                //         // onClick={() => console.log("HELLOOOOOO")}
                //         onClick={this.onImageDownload}
                //         size="large"
                //         edge="end"
                //     >
                //         <CloudDownloadRounded />
                //     </IconButton>
                // }
                appbar
            >
                <SwipeableTabs
                    labels={["Stats", "Liste"]}
                    default="Stats"
                >
                    <Box>
                        {/* <Button color="primary" variant="contained">
                            Vider le Bac
                        </Button> */}
                        <List>
                            <ListItem>
                                <ListItemText>
                                    Total Articles: <Typography style={{display: "inline"}} variant="h6" color="secondary"><b>{sumBy(Object.values(this.state.SUBS), "quantity")}</b></Typography>
                                </ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText>
                                    Poids Total: <Typography style={{display: "inline"}} variant="h6" color="secondary"><b><Currency value={totalWeight / UNITS[wUnit]} suffix={` ${wUnit}`} /></b></Typography>
                                </ListItemText>
                                <ListItemSecondaryAction>
                                    {/* <ButtonGroup>
                                        <Button variant={(this.state.wUnit === "kg" ? "contained" : "outlined")} color={(this.state.wUnit === "kg" && "primary")} onClick={() => this.setState({ wUnit: "kg"})}>kg</Button>
                                        <Button variant={(this.state.wUnit === "g" ? "contained" : "outlined")} color={(this.state.wUnit === "g" && "primary")} onClick={() => this.setState({ wUnit: "g"})}>g</Button>
                                    </ButtonGroup> */}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText>
                                    Volume Total: <Typography style={{display: "inline"}} variant="h6" color="secondary"><b><Currency value={totalVolume / UNITS[volUnit]} suffix={` ${volUnit}`} /></b></Typography> / <Typography style={{display: "inline"}} variant="body1"><b><Currency value={volumeBin * UNITS.m3 / UNITS[volUnit]} suffix={` ${volUnit}`} /></b></Typography>
                                </ListItemText>
                                <ListItemSecondaryAction>
                                    {/* <ButtonGroup>
                                        <Button variant={(this.state.volUnit === "m3" ? "contained" : "outlined")} color={(this.state.volUnit === "m3" && "primary")} onClick={() => this.setState({ volUnit: "m3"})}>m3</Button>
                                        <Button variant={(this.state.volUnit === "cm3" ? "contained" : "outlined")} color={(this.state.volUnit === "cm3" && "primary")} onClick={() => this.setState({ volUnit: "cm3"})}>cm3</Button>
                                    </ButtonGroup> */}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText>
                                    Taux Remplissage: <Typography style={{display: "inline"}} variant="h6" color="secondary"><b><Currency value={((totalVolume / UNITS[volUnit])/(volumeBin * UNITS.m3 / UNITS[volUnit]) * 100)} suffix=" %" /></b></Typography>
                                </ListItemText>
                            </ListItem>
                        </List>
                        
                    </Box>
                    <ListLayout>
                        <TableHead>
                            <TableRow>
                                {/* <TableCell component="th"  style={{minWidth: "150px"}}>ID</TableCell> */}
                                <TableCell component="th" >Date</TableCell>
                                <TableCell component="th" >Type</TableCell>
                                <TableCell component="th" >Nom</TableCell>
                                <TableCell component="th" >Quantité</TableCell>
                                {/* <TableCell component="th" >Poids U</TableCell> */}
                                <TableCell component="th" >Poids Total</TableCell>
                                <TableCell component="th" >Volume</TableCell>
                                {/* <TableCell component="th" >Date du Retour</TableCell>
                                <TableCell component="th" >Dernière action</TableCell>
                                <TableCell component="th" >Shop</TableCell>
                                <TableCell component="th" >Commentaire</TableCell>
                                <TableCell component="th" >Statut</TableCell> */}
                            </TableRow>
                        </TableHead>
                        {Object.values(this.state.SUBS).map( item =>
                            <TableRow 
                                key={item.id} 
                                hover
                            >
                                {/* <TableCell ><b>{item.id.slice(0,13)}</b></TableCell> */}
                                <TableCell >{new Date(item.throw_date).toLocaleString("fr-FR")}</TableCell>
                                <TableCell >{BIN_TYPES[item.product[0].bin_type]}</TableCell>
                                <TableCell ><a href="#">{item.product[0].name}</a></TableCell>
                                <TableCell >{item.quantity}</TableCell>
                                {/* <TableCell >{item.product[0].poids}</TableCell> */}
                                <TableCell ><Currency value={item.product[0].poids * item.quantity} suffix=" g" /></TableCell>
                                <TableCell ><Currency value={(item.product[0].largeur * item.product[0].longueur * item.product[0].hauteur) * item.quantity} suffix=" mm3"/></TableCell>
                            </TableRow>
                        )}
                    </ListLayout>

                </SwipeableTabs>
            </PopUp>
        );
    }
}

export default SingleBin;

